import { Message } from 'element-ui'
import { debounce } from 'lodash'

const showError = (message) => {
  Message.error(message || '请求失败')
}

/**
 * 接口错误提示（防抖）：短时间内多次失败只按防抖策略提示，避免连续弹多条 Message。
 */
export const showApiErrorMessage = debounce(showError, 300, {
  leading: true,
  trailing: false
})
